import React, { useMemo } from 'react';
import { Content, Progress } from '@backstage/core-components';
import { Typography } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { getApiErrorMessage } from '../../../shared/api/getApiErrorMessage';
import { BackToIdentities } from '../components/IdentityDetails/BackToIdentities';
import { IdentityDetails } from '../components/IdentityDetails/IdentityDetails';
import { useTeamMembership } from '../components/IdentityDetails/useTeamMembership';
import { mapApiIdentityFromMembership } from '../components/IdentitiesGrid/mapApiIdentity';

export default function IdentityDetailsPage() {
  const { identityId } = useParams();
  const membershipQuery = useTeamMembership(identityId);
  const identity = useMemo(() => {
    if (!membershipQuery.data) {
      return undefined;
    }

    return mapApiIdentityFromMembership(membershipQuery.data);
  }, [membershipQuery.data]);

  if (membershipQuery.isPending) {
    return (
      <Content>
        <BackToIdentities />
        <Progress />
      </Content>
    );
  }

  if (membershipQuery.isError || !identity) {
    return (
      <Content>
        <BackToIdentities />
        <Typography>
          {getApiErrorMessage(membershipQuery.error, 'Identity not found')}
        </Typography>
      </Content>
    );
  }

  return (
    <Content>
      <IdentityDetails key={identity.id} identity={identity} />
    </Content>
  );
}
